import styled, { css } from 'styled-components';
import { Button } from '@material-ui/core';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-bottom: 20px;
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    margin-bottom: 30px;
    text-align: center;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: #000;
    opacity: 0.8;
    margin: 0 0 10px 0;
    padding: 0;
    font-size: 28px;
    font-weight: 600;
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    color: #666;
    margin: 0;
    font-size: 16px;
  `}
`;

export const SelectedRoomsSection = styled.div`
  ${({ theme }) => css`
    background: #f8f9fa;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
  `}
`;

export const AvailableRoomsSection = styled.div`
  ${({ theme }) => css`
    margin-bottom: 30px;
    min-height: 400px;
  `}
`;

export const SectionTitle = styled.h3`
  ${({ theme }) => css`
    color: #000;
    opacity: 0.8;
    margin: 0 0 20px 0;
    font-size: 20px;
    font-weight: 600;
  `}
`;

export const SelectedRoomCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);

    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const SelectedRoomInfo = styled.div`
  ${({ theme }) => css`
    flex: 1;
  `}
`;

export const RoomNumber = styled.div`
  ${({ theme }) => css`
    font-weight: 600;
    color: ${theme.palette.primary.main};
    font-size: 14px;
    margin-bottom: 5px;
  `}
`;

export const RoomName = styled.div`
  ${({ theme }) => css`
    font-weight: 500;
    color: #000;
    opacity: 0.8;
    font-size: 16px;
    margin-bottom: 5px;
  `}
`;

export const RoomPrice = styled.div`
  ${({ theme }) => css`
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 2px;
  `}
`;

export const RoomPriceDaily = styled.div`
  ${({ theme }) => css`
    color: #666;
    font-size: 12px;
    font-style: italic;
  `}
`;

export const RemoveButton = styled(Button)`
  ${({ theme }) => css`
    background: #dc3545 !important;
    color: white !important;
    padding: 8px 16px !important;
    font-size: 12px !important;
    min-width: auto !important;

    &:hover {
      background: #c82333 !important;
    }
  `}
`;

export const RoomWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: 20px;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const ProceedSection = styled.div`
  ${({ theme }) => css`
    text-align: center;
    margin-top: 30px;
    padding: 20px 0;
    border-top: 2px solid #e9ecef;
  `}
`;

export const ProceedButton = styled(Button)`
  ${({ theme, canProceed }) => css`
    background: ${canProceed ? theme.palette.primary.main : '#ccc'} !important;
    color: white !important;
    padding: 15px 40px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    min-width: 250px !important;
    cursor: ${canProceed ? 'pointer' : 'not-allowed'} !important;

    &:hover {
      background: ${canProceed ? theme.palette.primary.dark : '#ccc'} !important;
    }

    &:disabled {
      color: #666 !important;
    }
  `}
`;

export const TabsSection = styled.div`
  ${({ theme }) => css`
    margin-bottom: 30px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 12px;
    border: 1px solid #e9ecef;
  `}
`;

export const TabsTitle = styled.h3`
  ${({ theme }) => css`
    margin: 0 0 20px 0;
    color: #000;
    opacity: 0.8;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  `}
`;

export const TabsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 15px;
    justify-content: center;
    flex-wrap: wrap;
  `}
`;

export const CustomTab = styled.div`
  ${({ theme, isActive, isCompleted }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    min-width: 140px;
    border-radius: 12px;
    border: 2px solid ${isActive ? theme.palette.primary.main : (isCompleted ? theme.palette.primary.light : '#ddd')};
    background: ${isActive ? theme.palette.primary.main + '10' : (isCompleted ? theme.palette.primary.light + '10' : 'white')};
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    box-shadow: ${isActive ? `0 4px 12px ${theme.palette.primary.main}40` : '0 2px 4px rgba(0,0,0,0.1)'};
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0,0,0,0.15);
    }
    
    ${isCompleted && css`
      &::after {
        content: '';
        position: absolute;
        top: -8px;
        right: -8px;
        width: 24px;
        height: 24px;
        background: ${theme.palette.primary.main};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
      }
    `}
  `}
`;

export const TabNumber = styled.div`
  ${({ theme, isActive, isCompleted }) => css`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${isCompleted ? theme.palette.primary.main : (isActive ? theme.palette.primary.main : '#ddd')};
    color: ${isCompleted || isActive ? 'white' : '#666'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: ${isCompleted ? '18px' : '16px'};
    margin-bottom: 10px;
    transition: all 0.3s ease;
  `}
`;

export const TabLabel = styled.div`
  ${({ theme, isActive }) => css`
    font-weight: 600;
    font-size: 14px;
    color: ${isActive ? theme.palette.primary.main : '#333'};
    margin-bottom: 5px;
    text-align: center;
  `}
`;

export const TabRoomName = styled.div`
  ${({ theme }) => css`
    font-size: 12px;
    color: ${theme.palette.primary.main};
    font-weight: 500;
    text-align: center;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;

export const SelectedIndicator = styled.span`
  ${({ theme }) => css`
    color: ${theme.palette.primary.main};
    font-weight: 500;
    font-size: 14px;
  `}
`;

export const NoRoomsMessage = styled.div`
  ${({ theme }) => css`
    text-align: center;
    color: #999;
    font-style: italic;
    padding: 40px;
    border: 2px dashed #ddd;
    border-radius: 8px;
    background: #f8f9fa;
  `}
`;

export const AllRoomsSelectedSection = styled.div`
  ${({ theme }) => css`
    text-align: center;
    padding: 60px 20px;
    background: linear-gradient(135deg, ${theme.palette.primary.main}08 0%, ${theme.palette.primary.light}15 100%);
    border: 2px solid ${theme.palette.primary.main}30;
    border-radius: 16px;
    margin: 20px 0;
  `}
`;

export const CompletionIcon = styled.div`
  ${({ theme }) => css`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: ${theme.palette.primary.main};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    font-weight: bold;
    margin: 0 auto 20px;
    animation: pulse 2s infinite;
    box-shadow: 0 4px 20px ${theme.palette.primary.main}40;
    
    @keyframes pulse {
      0% {
        transform: scale(1);
        box-shadow: 0 4px 20px ${theme.palette.primary.main}40;
      }
      50% {
        transform: scale(1.05);
        box-shadow: 0 6px 25px ${theme.palette.primary.main}60;
      }
      100% {
        transform: scale(1);
        box-shadow: 0 4px 20px ${theme.palette.primary.main}40;
      }
    }
  `}
`;

export const CompletionTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.palette.primary.main};
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 15px 0;
  `}
`;

export const CompletionSubtitle = styled.p`
  ${({ theme }) => css`
    color: #666;
    font-size: 16px;
    line-height: 1.6;
    margin: 0;
    max-width: 500px;
    margin: 0 auto;
  `}
`;

export const SelectedRoomsHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  `}
`;

export const TotalPrice = styled.div`
  ${({ theme }) => css`
    font-size: 18px;
    font-weight: 600;
    color: ${theme.palette.primary.main};
    
    span {
      font-size: 20px;
      font-weight: 700;
    }
  `}
`;

export const ProceedSectionInline = styled.div`
  ${({ theme }) => css`
    text-align: center;
    margin-top: 30px;
    padding: 20px 0 0 0;
    border-top: 2px solid #e9ecef;
  `}
`;